'use strict';

var React = require('react');

var SvgComposeMajor = function SvgComposeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 9a1 1 0 0 0-1 1v7h-14v-14h7a1 1 0 1 0 0-2h-7.5a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-7.5a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.53 2.029 2.439 2.44-7.739 7.738-3.23.792.792-3.231 7.738-7.74zm3.558 1.321-2.438-2.437.406-.407a1.725 1.725 0 0 1 2.44 2.439l-.408.407z"
  }));
};

exports.SvgComposeMajor = SvgComposeMajor;
